import {getLocalizationBasedOnLang} from '../../../data/models/User/UserInfo';

const english = {
  lastVideoFrame: 'Last video frame',
  options: 'Options',
  imageChoice: 'Image choice',
  freeformText: 'Text choice',
  freeformShape: 'Shape choice',
  imageChoiceTitle: 'Image choice title',
  freeformTextInput: 'Text choice:',
  title: 'Title',
  cancel: 'Cancel',
  save: 'Save',
  fontSize: 'Font size:',
  textColor: 'Text color:',
  color: 'Color',
  addPoint: 'Add point',
  removePoint: 'Remove point',
  showOverlay: 'Show overlay for learners?',
};

const welsh = {
  lastVideoFrame: 'Ffrâm fideo olaf',
  options: 'Opsiynau',
  imageChoice: 'Dewis delwedd',
  freeformText: 'Dewis testun',
  freeformShape: 'Dewis siâp',
  imageChoiceTitle: 'Teitl dewis delwedd',
  freeformTextInput: 'Dewis testun',
  title: 'Teitl',
  cancel: 'Canslo',
  save: 'Cadw',
  fontSize: 'Maint y ffont',
  textColor: 'Lliw testun',
  color: 'Lliw',
  addPoint: 'Ychwanegwch pwynt',
  removePoint: 'Dileu pwynt',
  showOverlay: 'Dangos troshaen i ddysgwyr?',
};

export const addFreeformChoiceText: any = getLocalizationBasedOnLang(
  english,
  welsh,
);
